import { BaseFieldProps } from "@/components/Form/RHF/FormFields/BaseField/BaseField.component";
import { CheckBoxField } from "@/components/Form/RHF/FormFields/CheckboxField/CheckBoxField.component";

import { useCheckoutCustomerContext } from "../../checkoutCustomer.context";
import { BoxConditionsFormValues } from "../boxConditions.schema";

type BoxPartnerConditionComponentProps<_ extends BoxConditionsFormValues> =
    Omit<
        BaseFieldProps<
            BoxConditionsFormValues,
            "boxConditions.partnerCondition"
        >,
        "name" | "required"
    > & {
        required: boolean;
    };

const BoxPartnerConditionComponent = <T extends BoxConditionsFormValues>({
    required,
    label
}: BoxPartnerConditionComponentProps<T>) => {
    const { boxPartnerConditionMicroCopy } = useCheckoutCustomerContext();

    return (
        <CheckBoxField<BoxConditionsFormValues>
            name={"boxConditions.partnerCondition"}
            label={label}
            required={required}
            microCopy={boxPartnerConditionMicroCopy}
        />
    );
};

export { BoxPartnerConditionComponent };
